import React, { Component } from 'react';
import PropTypes from 'prop-types';

import branch from 'client/core/branch';
import UserActions from 'client/actions/User';

@branch()
class SrEducationalTour extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  }

  _onCloseButtonClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.props.dispatch(UserActions.updateSettings, {
      educationTourCardClosed: true,
    });
  }

  render() {

    return (
      <div className='promptCard educationalTour imageBottom'>
        <div onClick={this._onCloseButtonClick} className='xClose' />
        <div className='mapPin one' />
        <div className='mapPin two' />
        <div className='mapPin three' />
        <svg x='0px' y='0px' width='213.952px' height='109.952px' viewBox='0 0 213.952 109.952'>
          <path
            fill='none'
            stroke='#FFCD00'
            strokeWidth='3'
            strokeMiterlimit='10'
            d={
              'M0.745,1.302c47.188,26.99,80.055,29.428,77.781,32.699c-13.828,' +
              '50.854-18.869,40.713,4.035,48.275s77.193,27.662,77.842,26.088' +
              'c10.863-44.887,11.436-57.484,40.385-44.984c12.385,3.483,14.908-5.602,7.566-27.254'
            }
          />
        </svg>
        <div className='textContainer'>
          <span className='category'>one-click to tour</span>
          <span className='headline'>
            Tour homes at the push of a button <span role='img' aria-label='fast car'>🚗💨</span>
          </span>
          <span className='subhead'>
            <span role='img' aria-label='lightning bolt'>⚡ </span>️
            Sunroom will respond in minutes.
          </span>
        </div>
      </div>
    );
  }
}

export default SrEducationalTour;
